export default __webpack_public_path__ + "static/media/mobile-verify.ee5a28ca.png";